// export const BASE_URL="http://localhost:8003"
// export const BASE_URL="https://ots-server.vercel.app" // LIVE URL
export const BASE_URL="https://api.ownertenantsolution.com" // LIVE URL
export const PAYMENT_BASE_URL="https://detector-refusing-wrecking.ngrok-free.dev"